import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { ParameterType } from 'types';
import ActionCreators from 'actions/ActionCreators';
import Checkbox from 'components/CheckboxControl';
import { arrayContainsValue } from 'core/utils.js';

import './TransportationModesPane.scss';

class TransportationModesPane extends Component {

    static propTypes = {
        parameters: PropTypes.objectOf(ParameterType).isRequired
    };

    constructor(props) {
        super(props);
        var options = new Set();
        var parameters = this.props.parameters.transportation_modes.value;

        if (parameters) {
            for (var i = 0; i < parameters.length; i++) {
                options.add(parameters[i]);
            }
        }

        this.state = {
            options: options
        };
    }

    componentWillMount() {
        //
    }

    _onParameterChange = (e) => {
        var id = parseInt(e.target.name);
        var checked = e.target.checked;

        if (checked) {
            this.state.options.add(id);
        } else {
            this.state.options.delete(id);
        }

        ActionCreators.updateParameter({
            'transportation_modes': this.state.options.toJSON()
        });
    };

    renderParameter = (parameter) => {
        var parameters = this.props.parameters.transportation_modes.value;
        var checked = arrayContainsValue(parameters, [parameter.id]);

        return (
            <Checkbox key={ parameter.id } type="checkbox"
                      label={ parameter.value }
                      name={ parameter.id }
                      value={ checked }
                      onChange={ this._onParameterChange }
                />
        );
    };

    renderParameters = () => {
        var parameters = this.props.parameters.transportation_modes.values;
        var list = [];

        for (var id in parameters) {
            if (!parameters.hasOwnProperty(id)) continue;
            list.push(this.renderParameter(parameters[id]));
        }
        return list;
    };

    render() {
        return (
            <div className="TransportationModesPane">
                { this.renderParameters() }
            </div>
        );
    }

}

export default TransportationModesPane;



// WEBPACK FOOTER //
// ./client/components/ParametersScreen/TransportationModesPane.js